import { createURLPath } from '@/utils/paths/path-factory';
import type { models } from 'cesg-shared';
import { appHttpService } from '../standard/http-service';

const debitNormsPath = createURLPath('debit-norms');

class DebitNormsService {
  getDebitNormsForProject(projectId: string) {
    return appHttpService.request
      .url(debitNormsPath('projects', projectId))
      .get()
      .json<models.GetDebitNormsFromProjectResponse>();
  }

  setProjectDebitNorms(projectId: string, body: models.UpsertDebitNormRequest) {
    return appHttpService.request
      .url(debitNormsPath('projects', projectId))
      .post(body)
      .res();
  }
}

export const debitNormsService = new DebitNormsService();
